import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBundle } from '@amzn/react-arb-tools';
import SideNavigation, {
  SideNavigationProps,
} from '@amzn/awsui-components-core/side-navigation';
import { NAV_MODEL } from 'src/routes/valueMatching/routes';
import { NAV_MESSAGE_BUNDLE } from 'src/constants';
import { t } from 'src/utils/helpers';
import { monitor, METRIC_NAMES } from 'src/utils/monitoring';

const Nav: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [bundle] = useBundle(NAV_MESSAGE_BUNDLE);

  const handleFollow: SideNavigationProps['onFollow'] = (e) => {
    e.preventDefault();
    monitor.count(METRIC_NAMES.NAVIGATION_CLICK, 1, {
      route: e.detail.href,
      methodName: 'Navigation',
    });
    navigate(e.detail.href);
  };

  const navItems: SideNavigationProps.Item[] = [];
  NAV_MODEL.links.forEach(({ to, sid }, index) => {
    if (index > 0) {
      navItems.push({ type: 'divider' });
    }
    navItems.push({
      type: 'link',
      href: to,
      text: t(bundle, sid),
    });
  });

  return (
    <SideNavigation
      activeHref={location.pathname}
      onFollow={handleFollow}
      items={navItems}
    />
  );
};

export default Nav;